//
//
//
//
//
//
//
//
//
//
//

import UImage from 'cloud-ui.vusion/src/components/u-image.vue/index.vue';
export default {
    components: {
        UImage,
    },
    props: {
        value: Array,
        list: Array,
    },
    data() {
        return {
            selectedList: this.getSelectedList(this.value),
        };
    },
    watch: {
        value(value) {
            this.selectedList = this.getSelectedList(value);
        },
    },
    methods: {
        getCurrentImage(item) {
            if (item.files[0]) {
                return item.files[0].url;
            }
            return item.image;
        },
        getSelectedList(value) {
            const map = {};
            // 选项的 text 作为唯一标识
            this.list.forEach((item) => {
                map[item.text] = item;
            });

            // 根据结果返回选中的值
            let valueResult = [];
            if (Object.prototype.toString.call(value) === '[object Array]') {
                valueResult = value;
            } else {
                valueResult = (value || '').split(',').filter((i) => i);
            }

            return valueResult.map((valueItem) => {
                const realItem = this.list.find((item) => item.text === valueItem);
                return realItem;
            });
        },
    },
};
